const UPDATE_PRICE_DISPLAY_DISCLAIMER = "updatePriceDisplayDisclaimer";
const ADD_TO_LEAFLET_LIST = "addToLeafletList";
const REMOVE_FROM_LEAFLET_LIST = "removeFromLeafletList";
const EMPTY_LEAFLET_LIST = "emptyLeafletList";
const SET_APPLICATION_CONFIG = "setApplicationConfig";

const state = {
  priceDisplayDisclaimer: true,
  leafletList: [],
  applicationConfig: {}
};
const getters = {
  getProductsByLeafletId: state => leafletId => {
    const index = state.leafletList.findIndex(
      el => el.leaflet.leafletId == leafletId
    );
    if (index != -1) {
      return state.leafletList[0].products;
    } else return [];
  },
  getApplicationConfig: state => {
    return state.applicationConfig;
  }
};

const actions = {
  [UPDATE_PRICE_DISPLAY_DISCLAIMER]({ commit }, value) {
    commit(UPDATE_PRICE_DISPLAY_DISCLAIMER, value);
  },
  [ADD_TO_LEAFLET_LIST]({ commit }, value) {
    commit(ADD_TO_LEAFLET_LIST, value);
  },
  [REMOVE_FROM_LEAFLET_LIST]({ commit }, value) {
    commit(REMOVE_FROM_LEAFLET_LIST, value);
  },
  [EMPTY_LEAFLET_LIST]({ commit }, value) {
    commit(EMPTY_LEAFLET_LIST, value);
  },
  [SET_APPLICATION_CONFIG]({ commit }, value) {
    commit(SET_APPLICATION_CONFIG, value);
  }
};

const mutations = {
  [UPDATE_PRICE_DISPLAY_DISCLAIMER]: (state, value) => {
    state.priceDisplayDisclaimer = value;
  },
  [ADD_TO_LEAFLET_LIST]: (state, { product, leaflet }) => {
    const index = state.leafletList.findIndex(
      el => el.leaflet.leafletId === leaflet.leafletId
    );
    if (index != -1) {
      const found = state.leafletList[index].products.find(
        el => el.productId === product.productId
      );
      if (!found) {
        state.leafletList[index].products.push(product);
        global.EventBus.$emit("success", {
          message: global.vm.$t("leaflet.list.productAddText")
        });
      }
    } else {
      state.leafletList.push({ leaflet: leaflet, products: [product] });
      global.EventBus.$emit("success", {
        message: global.vm.$t("leaflet.list.productAddText")
      });
    }
  },
  [REMOVE_FROM_LEAFLET_LIST]: (state, { productId, leafletId }) => {
    const index = state.leafletList.findIndex(
      el => el.leaflet.leafletId == leafletId
    );
    if (index != -1) {
      for (let i = 0; i < state.leafletList[0].products.length; i++) {
        if (state.leafletList[0].products[i].productId == productId) {
          state.leafletList[0].products.splice(i, 1);
          break;
        }
      }
    }
  },
  [EMPTY_LEAFLET_LIST]: (state, value) => {
    const index = state.leafletList.findIndex(
      el => el.leaflet.leafletId == value
    );
    if (index != -1) {
      state.leafletList.splice(index, 1);
    }
  },
  [SET_APPLICATION_CONFIG]: (state, value) => {
    state.applicationConfig = value;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
